export const environment = {
  environment: 'development',
  apiUrl: 'https://api.functionalacademics-dev.com',
  appUrl: 'https://app.functionalacademics-dev.com',
  amplitudeApiKey: 'df9581f360d34a732dafac40e9f149f4',
}
